//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

import { Box, Grid, Stack, Typography } from "@mui/material";
import { MprcContainer, MprcSpinnerIndicator } from "components";
import { AutoCompleteHierarchicalModel } from "components/MprcAutoCompleteHierarchical";
import { MprcChipSuggestion } from "components/MprcChipSuggestion";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TopicAutoCompleteHierarchical } from "views/foundation/topic/components/TopicAutoCompleteHierarchical";

export interface IPublicationchannelBoxValidation {
    topics?: boolean;
}

interface IDataProps {
    topics: AutoCompleteHierarchicalModel[];
    suggestions: AutoCompleteHierarchicalModel[];
    publication: {
        title: string | null;
        content: string | null;
    } | null;
}

interface IProps extends IDataProps {
    channelId?: string | null;
    title?: string;
    onUpdateState: (topics: AutoCompleteHierarchicalModel[]) => void;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const PublicationTopicsBox: React.FC<IProps> = ({ publication, topics, channelId, suggestions, onUpdateState, title }) => {
    const { t } = useTranslation("knowledge");
    const api = useCoreApi();
    const [allSuggestions, setAllSuggestions] = useState<AutoCompleteHierarchicalModel[]>([]);
    const [loading, setLoading] = useState(false);

    ///
    useEffect(() => {
        async function getSuggestions() {
            if (channelId != null) {
                try {
                    setLoading(true);
                    const result = await api.v1.knowledgePublication.getChannelTopicsSuggestionsQuery({
                        ChannelId: channelId,
                        PublicationTitle: publication?.title ?? undefined,
                        PublicationContent: publication?.content ?? undefined
                    });
                    setAllSuggestions([...suggestions, ...(result.data as AutoCompleteHierarchicalModel[]).filter(x => !suggestions.some(a => a.key == x.key))]);
                }
                catch {
                }
                finally {
                    setLoading(false);
                }
            }
            else
                setAllSuggestions(suggestions);
        }

        getSuggestions();
    }, [channelId, suggestions]);

    ///
    return (
        <MprcContainer>

            <Typography variant="button">{title ?? t("Publication.TopicBox.Title")}</Typography>

            <TopicAutoCompleteHierarchical
                selectedMode="assignment"
                placeholder={t("Publication.TopicBox.Placeholder")}
                multiSelect={true}
                maxSelectItems={5}
                selectedItems={topics.map(m => ({ ...m, canDelete: true }))}
                onChange={(items) => onUpdateState(items)}
                onError={() => { }}
            />

            <Box>
                <Grid container justifyContent="center" alignItems="baseline">
                    <Grid>
                        <Stack direction="row" alignItems="center">
                            {allSuggestions.length > 0 &&
                                <Typography variant="captionHeader">{t("Publication.TopicBox.SuggestionsText")}</Typography>
                            }
                            {loading && <MprcSpinnerIndicator />}
                        </Stack>
                    </Grid>
                    {allSuggestions.length > 0 &&
                        <Grid size="grow">
                            {
                                allSuggestions.map((item) => (
                                    <MprcChipSuggestion
                                        key={item.key}
                                        label={item.label}
                                        title={item.label}
                                        disabled={topics.length >= 5}
                                        onClick={() => {
                                            if (!topics.some(x => x.key == item.key))
                                                onUpdateState([...topics, item]);
                                        }}
                                    />
                                ))
                            }
                        </Grid>
                    }
                </Grid>
            </Box>
        </MprcContainer>
    );
};
